"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const linkset_es6_1 = require("linkset-es6");
const menu_element_1 = require("./menu-element");
class Menu {
    constructor(machineName, linkset) {
        this.id = machineName;
        this.linkset = linkset;
        this.elements = this.linkset.elements;
        this.size = this.linkset.size;
        this.tree = (0, menu_element_1.buildTree)([...this.elements]);
    }
    [Symbol.iterator]() {
        const elems = this.elements;
        let pointer = 0;
        return {
            next() {
                if (pointer < elems.length) {
                    return { value: elems[pointer++], done: false };
                }
                else {
                    return { value: undefined, done: true };
                }
            },
        };
    }
    /**
     * {@inheritDoc LinksetInterface.hasLinkTo}
     */
    hasLinkTo(relationType) {
        return this.linkset.hasLinkTo(relationType);
    }
    /**
     * {@inheritDoc LinksetInterface.linkTo}
     */
    linkTo(relationType) {
        return this.linkset.linkTo(relationType);
    }
    /**
     * {@inheritDoc LinksetInterface.linksTo}
     */
    linksTo(relationType) {
        return new Menu(this.id, this.linkset.linksTo(relationType));
    }
    /**
     * {@inheritDoc LinksetInterface.linksFrom}
     */
    linksFrom(anchor) {
        return new Menu(this.id, this.linkset.linksTo(anchor));
    }
    /**
     * {@inheritdoc LinksetInterface.linksWithAttribute}
     */
    linksWithAttribute(name) {
        return new Menu(this.id, this.linkset.linksWithAttribute(name));
    }
    /**
     * {@inheritdoc LinksetInterface.linksWithAttributeValue}
     */
    linksWithAttributeValue(name, value) {
        return new Menu(this.id, this.linkset.linksWithAttributeValue(name, value));
    }
    /**
     * Creates a new menu from a normalized linkset.
     * @param normalized
     *   A normalized linkset.
     * @param menuID
     *   A menu machine name.o
     * @returns a new Menu object containing only link elements belonging to the given menu.
     */
    static from(normalized, menuID) {
        const linkset = (0, linkset_es6_1.denormalize)(normalized);
        const machineNames = [];
        if (!menuID) {
            linkset.linksWithAttribute('machine-name').elements.forEach((link) => {
                if (!machineNames.includes(link.attributes['machine-name'][0])) {
                    machineNames.push(link.attributes['machine-name'][0]);
                }
            });
        }
        else {
            machineNames.push(menuID);
        }
        const menus = machineNames.map((machineName) => {
            return new Menu(machineName, linkset.linksWithAttributeValue('machine-name', machineName));
        });
        return menuID ? menus.shift() : menus;
    }
}
exports.Menu = Menu;
